export const parseTheoremArguments = (state, node) => {
    const nameArgumentNode = node.getChild("ShortTextArgument")?.getChild("ShortArg");
    const labelArgumentNode = node.getChild("TextArgument")?.getChild("LongArg");

    if (nameArgumentNode && labelArgumentNode) {
        const name = state.sliceDoc(nameArgumentNode.from, nameArgumentNode.to).trim();
        const label = state.sliceDoc(labelArgumentNode.from, labelArgumentNode.to).trim();
        if (name && label) {
            return { name, label };
        }
    }
    return undefined;
};

export const parseTheoremStyles = (state, tree) => {
    let currentTheoremStyle = "plain";
    const theoremStyles = new Map();
    const topNode = tree.topNode;
    if (topNode && topNode.name === "LaTeX") {
        const textNode = topNode.getChild("Text");
        const topLevelCommands = textNode ? textNode.getChildren("Command") : topNode.getChildren("Command");
        for (const command of topLevelCommands) {
            const node = command.getChild("KnownCommand")?.getChild("$Command");
            if (!node) {
                continue;
            }
            if (node.type.is("TheoremStyleCommand")) {
                const style = argumentNodeContent(state, node);
                if (style) {
                    currentTheoremStyle = style;
                }
            } else if (node.type.is("NewTheoremCommand")) {
                const theoremEnvironmentName = argumentNodeContent(state, node);
                if (theoremEnvironmentName) {
                    theoremStyles.set(theoremEnvironmentName, currentTheoremStyle);
                }
            }
        }
    }
    return theoremStyles;
};

function argumentNodeContent(state, node) {
    const argumentNode = node.getChild("ShortTextArgument")?.getChild("ShortArg");
    return argumentNode ? state.sliceDoc(argumentNode.from, argumentNode.to) : null;
}
